import axiosClient from '../../configs/axios';


class SupplierMasterService {
    // Get list 
    async getSupplierList(params) {
        try {
            const response = await axiosClient.get(
                `/supplier/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addSupplier(data) {
        try {
            const response = await axiosClient.post('/supplier/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteSupplier(data) {
        try {
            const response = await axiosClient.put(`/supplier/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new SupplierMasterService(); 